import React, { useEffect, useCallback } from "react";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  Polygon,
  DrawingManager,
} from "@react-google-maps/api";
import "@reach/combobox/styles.css";
import mapStylesClear from "../../../../components/MapsGoogle/mapStylesClear";

const libraries = ["places"];

const options = {
  styles: mapStylesClear,
  fullscreenControl: true,
  disableDefaultUI: true,
  zoomControl: true,
  zoom: 15,
};
const center = {
  lat: -33.448891,
  lng: -70.669266,
};
const rosettaVehicles = {
  BICYCLING: "Bicicleta",
  VEHICLE: "Bicicleta",
  TWO_WHEELER: "Motorizado",
  DRIVING: "Vehículo",
  WALKING: "Caminante",
};

export default function PlannerMapDistribucionAssing2(props) {
  const [markersPending, setMarkersPending] = React.useState(null);
  const [path, setPath] = React.useState([]);
  const [selectedPolygon, setSelectedPolygon] = React.useState(null);
  const [selectedMarker, setSelectedMarker] = React.useState("");
  const [colorFill, setColor] = React.useState("#591e8f");
  const [confHeight, setConfHeight] = React.useState(props.confHeight);
  const [confWidth, setConfWidth] = React.useState(props.confWidth);
  const mapContainerStyle = {
    height: props.confHeight,
    width: props.confWidth,
  };

  useEffect(() => {
    if (
      props.markerpoint &&
      props.markerpoint[0] &&
      props.markerpoint[0].toAddressLocation
    ) {
      setMarkersPending(props.markerpoint);
    } else {
    }
  }, [props.markerpoint]);

  // Mira el estado path con useEffect
  React.useEffect(() => {
    findPoints();
  }, [path]);

  const google = window.google;

  const polygonRef = React.useRef(null);

  const listenersRef = React.useRef([]);

  const onPolygonComplete = (polygon) => {
    polygonRef.current = polygon;
    const newCoordinates = polygon
      .getPath()
      .getArray()
      .map((latLng) => {
        return { lat: latLng.lat(), lng: latLng.lng() };
      });
    setPath(newCoordinates);
    polygon.setDraggable(true);
    polygon.setEditable(true);
    polygon.addListener("mouseup", onEdit);
    polygon.addListener("dragend", onEdit);
    polygon.addListener("mouseup", onEdit);
    polygon.addListener("onLoad", onLoad);
    polygon.addListener("onUnmount", onUnmount);
    // setSelectedPolygon is not defined in your provided code
    // setSelectedPolygon({
    //   polygon: polygon,
    //   coordinates: newCoordinates,
    // });
  };

  const onEdit = React.useCallback(() => {
    if (polygonRef.current) {
      const nextPath = polygonRef.current
        .getPath()
        .getArray()
        .map((latLng) => {
          return { lat: latLng.lat(), lng: latLng.lng() };
        });
      setPath(nextPath);
    } else {
    }
  }, []);

  const onLoad = useCallback(
    (polygon) => {
      polygonRef.current = polygon;
      const path = polygon.getPath();
      listenersRef.current.push(
        path.addListener("set_at", onEdit),
        path.addListener("insert_at", onEdit),
        path.addListener("remove_at", onEdit)
      );
    },
    [onEdit]
  );

  const onUnmount = useCallback(() => {
    listenersRef.current.forEach((lis) => lis.remove());
    polygonRef.current = null;
  }, []);

  const [polygonOptions, setPolygonOptions] = React.useState({
    editable: true,
    draggable: true,
    // onMouseUp and onDragEnd should be function handlers, not objects
    // onLoad and onUnmount are not valid polygon options
    strokeWeight: 1,
    fillOpacity: 0.3,
    fillColor: "#010101",
    strokeColor: "#010101",
    strokeOpacity: 0.8,
  });

  const onSelectPolygon = (polygon) => {
    polygonRef.current = polygon;
    setSelectedPolygon({
      polygon: polygonRef.current,
      coordinates: polygonRef.path,
    });
  };

  async function findPoints() {
    const polygon = new google.maps.Polygon({
      paths: path,
    });
    if (markersPending) {
      const markersInPolygon = markersPending.filter((marker) => {
        const markerPosition = new window.google.maps.LatLng(
          marker.toAddressLocation.lat,
          marker.toAddressLocation.lng
        );

        const isInside = google.maps.geometry.poly.containsLocation(
          markerPosition,
          polygon
        );
        return isInside;
      });

      if (markersInPolygon) {
        markersInPolygon.forEach((marker) => {
          // Imprimir más información del marcador si es necesario
        });
        props.setSeleccionByMapDataWaitPoints(markersInPolygon);
      } else {
        console.log("No detecto nuevas marcas");
      }
    } else {
      //      console.log("No detecto nuevas puntos den props");
    }
  }

  function getdata() {
    //polygon.addPolygon(polygonOptions);
    setPolygonOptions({ ...polygonOptions, fillColor: colorFill.hex });
  }

  return markersPending ? (
    <div>
      <div className="mapControlStyle">
        <GoogleMap
          id="mapControl2"
          mapContainerStyle={mapContainerStyle}
          zoom={13}
          center={center}
          options={options}
        >
          <DrawingManager
            onPolygonComplete={onPolygonComplete}
            defaultDrawingMode={google.maps.drawing.OverlayType.POLYGON}
            options={{
              drawingControl: true,
              drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: [
                  // google.maps.drawing.OverlayType.CIRCLE,
                  // google.maps.drawing.OverlayType.RECTANGLE,
                  google.maps.drawing.OverlayType.POLYGON,
                ],
              },
              polygonOptions: polygonOptions,
            }}
          ></DrawingManager>
          {selectedPolygon && (
            <Polygon
              paths={selectedPolygon.coordinates}
              onClick={() => onSelectPolygon(selectedPolygon.polygon)}
              // Resto de las propiedades
              editable={true}
              draggable={true}
              onMouseUp={onEdit}
              onDragEnd={onEdit}
              onLoad={onLoad}
            />
          )}
          {
            //  console.log(markerGroups)
          }
          {markersPending.length > 0 ? (
            <>
              <div>
                {markersPending.map((marker, index) => {
                  let colorMarket;
                  var validateStatus = parseInt(marker.status);

                  if (!marker.toAddressLocation) {
                    console.log("error", marker);
                    return null;
                  }
                  if (validateStatus >= 8) {
                    return (
                      <Marker
                        key={index}
                        position={{
                          lat: marker.toAddressLocation.latitude
                            ? marker.toAddressLocation.latitude
                            : 0,
                          lng: marker.toAddressLocation.longitude
                            ? marker.toAddressLocation.longitude
                            : 0,
                        }}
                        onClick={() => {
                          setSelectedMarker(marker);
                        }}
                        onLoad={(markerInstance) => {
                          const customIcon = {
                            url: "/static/images/casaDelivery.png", // URL de la imagen que quieres usar
                            scaledSize: new window.google.maps.Size(35, 35), // Tamaño al que se escalará la imagen
                            anchor: new window.google.maps.Point(17.5, 17.5), // Ancla para la imagen (generalmente el centro o el punto en el que quieres que se ancle en el mapa)
                          };
                          markerInstance.setIcon(customIcon);
                        }}
                      />
                    );
                  }
                  if (validateStatus >= 0 && validateStatus < 8) {
                    return (
                      <Marker
                        key={index}
                        position={{
                          lat: marker.toAddressLocation.latitude
                            ? marker.toAddressLocation.latitude
                            : 0,
                          lng: marker.toAddressLocation.longitude
                            ? marker.toAddressLocation.longitude
                            : 0,
                        }}
                        onClick={() => {
                          setSelectedMarker(marker);
                        }}
                        onLoad={(markerInstance) => {
                          const customIcon = {
                            url: "/static/images/casaDelivery.png", // URL de la imagen que quieres usar
                            scaledSize: new window.google.maps.Size(35, 35), // Tamaño al que se escalará la imagen
                            anchor: new window.google.maps.Point(17.5, 17.5), // Ancla para la imagen (generalmente el centro o el punto en el que quieres que se ancle en el mapa)
                          };
                          markerInstance.setIcon(customIcon);
                        }}
                      />
                    );
                  }
                })}
              </div>
            </>
          ) : (
            <></>
          )}
          {selectedMarker ? (
            <>
              {
                <InfoWindow
                  position={{
                    lat: selectedMarker.toAddressLocation.latitude,
                    lng: selectedMarker.toAddressLocation.longitude,
                  }}
                  onCloseClick={() => {
                    setSelectedMarker(null);
                  }}
                >
                  <div>
                    <span
                      onClick={() => setSelectedMarker(null)}
                      className="posditonCloseInfo"
                    >
                      x
                    </span>
                    <h5>ID: {selectedMarker.id}</h5>
                    <div>
                      <a
                        className="nonstyle"
                        href={`tel:9${selectedMarker.userPhone}`}
                      >
                        Teléfono: {selectedMarker.userPhone}
                      </a>
                    </div>
                    <div>
                      <a
                        className="nonstyle"
                        href={`https://api.whatsapp.com/send?phone=${selectedMarker.userPhone}&text=Soporte%20BICCI%20:`}
                      >
                        WhatsApp: {selectedMarker.userPhone}
                      </a>
                    </div>
                    <div>Nombre : {selectedMarker.userName}</div>
                    <div>Destino : {selectedMarker.toAddress}</div>
                  </div>
                </InfoWindow>
              }
            </>
          ) : null}
        </GoogleMap>
      </div>
    </div>
  ) : null;
}
